// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SorterIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SorterIcon" ref={forwardedRef} {...props}>
      <path d="m4.996 8 5 5 5-5-.005-.005H5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SorterIcon = /* @__PURE__ */ Object.assign(SorterIconComponent, {
  displayName: 'SorterIcon',
});
